import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "aria-pressed"]

import { useUiStore } from '@/stores/ui';


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeToggle',
  setup(__props) {

const ui = useUiStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: "day-night",
    type: "button",
    "aria-label": _ctx.$t('theme.toggle'),
    "aria-pressed": _unref(ui).isLightTheme,
    class: _normalizeClass({ light: _unref(ui).isLightTheme }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(ui).toggleTheme()))
  }, [...(_cache[1] || (_cache[1] = [
    _createStaticVNode("<span class=\"ocean\" data-v-e7f1af3a><span class=\"ship\" data-v-e7f1af3a><span class=\"mast\" data-v-e7f1af3a><span class=\"sail-1\" data-v-e7f1af3a></span><span class=\"sail-2\" data-v-e7f1af3a></span></span></span></span><span class=\"moon\" data-v-e7f1af3a></span><span class=\"sun\" data-v-e7f1af3a></span>", 3)
  ]))], 10, _hoisted_1))
}
}

})